<template>
    <label class="tw:inline-flex tw:items-center tw:gap-2 tw:cursor-pointer">
        <ToggleSwitch v-bind="$attrs" />
        <slot />
    </label>
</template>

<script>
import { ToggleSwitch } from 'primevue';
/**
 * ESwitch - Abstraction wrapper around Primevue's ToggleSwitch
 */
export default {
    name: 'ESwitch',
    components: [ToggleSwitch],
    inheritAttrs: false,
};
</script>
